import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { MapLocalizationToProps, MapLocKey, withLocalization } from "UI/UI.React/HOC";
import { LinkButtonComponent, LinkButtonComponentProps } from "../LinkButtonComponent";
import { createLinkButtonClickAction } from "./actions";
import { getIsLoading } from "./selectors";

//Props napojené komponenty musí rozšiřovat props prezentační komponenty
export type LinkButtonProps = {
    /** Id instance */
    readonly dataKey: string;
    /** Lokalizační klíč textu a nápovědy */
    readonly locKey: string;
} & LinkButtonComponentProps;

type StateProps = Pick<LinkButtonComponentProps, "isLoading">;

const mapStateToProps: MapStateToProps<StateProps, LinkButtonProps, IAppState> = (state, { dataKey }) => ({
    isLoading: getIsLoading(state, dataKey),
});

type DispatchProps = Pick<LinkButtonComponentProps, "onClick">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, LinkButtonProps> = (dispatch, { dataKey }) => ({
    onClick: () => dispatch(createLinkButtonClickAction(dataKey)),
});

const mapToProps: MapLocalizationToProps<Pick<LinkButtonProps, "text" | "title">> = ({ text, title }) => ({
    text,
    title,
});

const mapLocKeyProp: MapLocKey<Omit<LinkButtonProps, "text" | "title">> = ({ locKey }) => ({
    locKey,
});

const LinkButtonConnected = connect(mapStateToProps, mapDispatchToProps)(LinkButtonComponent);
// eslint-disable-next-line react-redux/prefer-separate-component-file
export const LinkButton = withLocalization(mapToProps, mapLocKeyProp)(LinkButtonConnected);
